<script>
  import { roundMoney } from '@base/utils'

  export default {
    methods: {
      computeDiscountedPrice(price, discountPercent, validFrom = null, validTo = null) {
        if (!price || !discountPercent) return null
        if (!this.isDiscountActive(discountPercent, validFrom, validTo)) return null

        return roundMoney(price * (1 - discountPercent / 100))
      },

      isDiscountActive(discountPercent, validFrom = null, validTo = null) {
        if (!discountPercent) return false

        const now = new Date()

        if (validFrom && new Date(validFrom) > now) return false
        if (validTo && new Date(validTo) < now) return false

        return true
      },
    }
  }
</script>